import { responseErrorHandle } from '@/utils/utils';
import {
  getExceptionRecordType,
  getExceptionRecordList,
  handleExceptionRecord,
  searchDDBindRelationship,
} from '../services/index';

export default {
  namespace: 'exceptionRecord',
  state: {
    statusList: [],
    typeList: [],
  },
  effects: {
    // 获取异常业务枚举信息
    *  getExceptionRecordType ({ payload }, { call, put }) {
      const res = yield call( getExceptionRecordType, payload);

      // 0-异常状态， 1-异常类型
      if (payload.type === 0) {
        yield put({
          type: 'update',
          payload: {
            statusList: res?.result || [],
          },
        });
      }

      if (payload.type === 1) {
        yield put({
          type: 'update',
          payload: {
            typeList: res?.result || [],
          },
        });
      }
      responseErrorHandle(res);

      return res;
    },

    // 分页查询异常记录
    * getExceptionRecordList ({ payload }, { call }) {
      const res = yield call(getExceptionRecordList, payload);
      responseErrorHandle(res);
      return res;
    },

    // 异常处理操作
    * handleExceptionRecord ({ payload }, { call }) {
      const res = yield call(handleExceptionRecord, payload);
      responseErrorHandle(res);
      return res;
    },

    // 查询浙政钉人员数据信息
    * searchDDBindRelationship ({ payload }, { call }) {
      const res = yield call(searchDDBindRelationship, payload);
      responseErrorHandle(res);
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
